import { Input, Card, Radio, Button } from "antd";
import { useNavigate } from "react-router-dom";

import { RouteConstants } from "../../constants/ApplicationConstants/RouteConstants";
import styles from "../MasterManagement/index.module.less";
import ManualStorageRetrievalRequestTable from "./Table/ManualStorageRetrievalRequestTable";

const ManualStorageRetrievalRequest = () => {
  const navigate = useNavigate();
  const handleAddClick = () => {
    navigate(`${RouteConstants.BOOKING_RETRIEVAL_REQUEST_PAGE}/${RouteConstants.USER_FORM_ADD_PAGE}`);
  };
  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={styles["head-container"]}>
          <div className={styles["title-container"]}>
            <span>Manual Booking or Retrieval Request</span>
          </div>
          <div className={` ${styles["extra-container"]}`}>
            <Input.Search className={`gx-mb-0 ${styles["input-search"]}`} allowClear placeholder={`Search...`} />
            <Button onClick={handleAddClick} className={`button-gradiant gx-mb-0 add-button`}>
              Manual Booking or Retrieval
            </Button>
          </div>
        </div>
      }
    >
      <ManualStorageRetrievalRequestTable />
    </Card>
  );
};
export default ManualStorageRetrievalRequest;
